<template>
    <div>
        <message-component v-if="showMessage" :status="status" :message="message"></message-component>
        <form>
            <ul>
                <li v-for="preference in preferences">
                  <input
                          type="checkbox"
                          :name="preference.name"
                          :value="preference.value"
                          :id="preference.id"
                          :checked="preference.checked"
                          @click="saveSetting(preference)"
                      >
                      <label :for="preference.id">
                          <img :src="'../../images/icons/' + preference.icon">{{ preference.label }}
                      </label>
                </li>
              </ul>
        </form>
    </div>
</template>
<script>

    import MessageComponent from './MessageComponent.vue'
    import axios from 'axios'
    export default {
        components: { MessageComponent },
        props: [
            'fixture',
            'endpoint',
            'cards_checked',
            'goals_checked',
            'kickoff_checked',
            'translations'
        ],
        data() {
            return {
                preferences: {
                    cards: {
                        checked: false,
                        id: 'cards_' + this.fixture,
                        value: 'cards',
                        name: 'cards',
                        label: this.translations.red_cards,
                        icon: 'modal-cards.svg'
                    },
                    goals: {
                        checked: false,
                        id: 'goals_' + this.fixture,
                        value: 'goals',
                        name: 'goals',
                        label: this.translations.goals,
                        icon: 'modal-goals.svg'
                    },
                    kickoff: {
                        checked: false,
                        id: 'kickoff_' + this.fixture,
                        value: 'kickoff',
                        name: 'kickoff',
                        label: this.translations.kickoff,
                        icon: 'modal-kickoff.svg'
                    }
                },
                message : '',
                showMessage : false,
                status : 'generic'
            }
        },

        methods: {
            saveSetting: function (preference) {
                this.toggleCheckbox(preference);

                axios.post(this.endpoint, {
                    fixture : this.fixture,
                    event : preference.name,
                    value : preference.checked
                }).then((response) => {
                    this.message = this.translations.success;
                    this.status = 'success';
                    this.showMessage = true;
                }).catch((response) => {
                    this.message = this.translations.fail;
                    this.status = 'error';
                    this.showMessage = true;
                });
            },

            setCheckboxes: function () {
                this.preferences.cards.checked = (this.cards_checked == 'true');
                this.preferences.goals.checked = (this.goals_checked == 'true');
                this.preferences.kickoff.checked = (this.kickoff_checked == 'true');
            },

            toggleCheckbox: function (preference) {
                preference.checked = !preference.checked;
            }
        },

        mounted() {
            this.setCheckboxes();
        }
    }
</script>
